import {useTranslation} from "react-i18next";
import i18next from "i18next";
import {useState} from "react";
import ReactFlagsSelect from "react-flags-select";
import {useIsMobile} from "../../sizes/sizes";

const LanguageSwitcher = () =>{
    const { i18n } = useTranslation();
    const isMobile = useIsMobile();
    const [selected, setSelected] = useState(i18next.resolvedLanguage==="es"?"ES":"GB");

    return(
        <div className={"text-sm"}>
            <ReactFlagsSelect
                selected={selected}
                onSelect={(code) => {
                    i18n.changeLanguage(code==="ES"?"es":"en").then(()=>{setSelected(code)})
                }}
                countries={["ES", "GB"]}
                customLabels={{ GB: "English", ES: "Español" }}
                placeholder={"_"}
                showSelectedLabel={!isMobile}
            />
        </div>
    )
}
export default LanguageSwitcher
